<template>
  <v-card style="padding-left:0.16rem;margin-bottom:10px" @click="goDetail(item)" v-bind="$attrs">
    <v-list three-line subheader style="padding-bottom:0;" >
      <v-list-item style="min-height:54px;padding:0 8px;">
        <v-list-item-content style="padding:8;">
          <v-list-item-title style="min-height:1.6rem;">
            <div style="position:relative;">
              <span style="margin-right:0.2rem;position:absolute;top:-0.09rem;"><v-icon color="warning" style="font-size:1.05rem;">fa-volume-down</v-icon></span>
              <div style="margin-left:1rem;padding-top: 3px;">
                <v-badge class="us-v-badge" color="red accent-2" offset-x="0" offset-y="1" dot v-if="item.READ_SID === 0">
                  <span>{{item.DEVICE_TEXT}}</span>
                </v-badge>
                <span v-else>
                    <span>{{item.DEVICE_TEXT}}</span>
                </span>
                <v-icon color="grey" style="font-size:0.85rem;position:absolute;right:0.1rem;top:0.12rem;">fa fa-angle-right</v-icon>
              </div>
            </div>
            <v-divider style="margin: 10px 0;"></v-divider>
          </v-list-item-title>
            <v-list-item-subtitle style="margin-top:0.2rem;">
            <v-row no-gutters style="width:100%;">
              <span>
                <span style="color:#9e9e9e;">描述：</span>
                <!-- <span style="color:#67C23A;">{{alert_info.text}}</span> -->
                <span v-if="alert_info && alert_info.text" style="color:#67C23A;">{{alert_info.text}}</span>
                <span v-else style="color:#67C23A;">{{item.NOTIFY_CONTENT}}</span>
                <span style="color:#67C23A;">【恢复】</span>
                <span v-if="alert_info.value">
                  <span style="color:#9e9e9e;" >当前恢复值：</span>
                  <span style="color:#67C23A;">{{formatVal(alert_info.value)}}{{alert_info.unit ? alert_info.unit : ''}}</span>
                </span>
              </span>
            </v-row>
          </v-list-item-subtitle>
          <v-list-item-subtitle style="margin-top:0.2rem;">
            <v-row no-gutters style="width:100%;">
              <span style="color:#9e9e9e;">时间：</span>{{getMsgTimeFormat(item.ALERT_END_DATE)}}
              <!-- ，
              <span style="color:#9e9e9e;">持续时间：</span>{{getDuraStr(alert_info.alarm_span_time_s)}} -->
              <span v-if="item.alert_info && item.alert_info.IS_RESEND" style="color: #bdbdbd;font-size: 12px;">（补发）</span>
            </v-row>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

  </v-card>
</template>

<script>
export default {
  components: { },
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {
    alert_info() {
      const dataJson = JSON.parse(this.item.alert_info.EVT_PARAMS);
      return dataJson
    }
  },
  mounted() {
    // console.log(this.item)
  },
  created() {
  },
  activated() {
  },
  methods: {
    goDetail(item) {
      var that = this
      that.$api.bz.setDeviceNotifyRead({ code: item.NOTIFY_CODE }).then(res => {
        item.READ_SID = 2;
        // that.$router.goPage('/AlertContent/' + item.ALERT_RECORD_CODE + '?has_back=true')
        that.$router.goPage('/AlertContentV3/' + item.NOTIFY_CODE + '?has_back=true')
      })
    },
    // 格式化时间显示
    getMsgTimeFormat(time) {
      var that = this
      var mt = that.$moment(time)
      var tv = mt.format('YYYY-MM-DD')
      var now = that.$moment(new Date()).format('YYYY-MM-DD')
      if (tv < now) {
        var zt = that.$moment(new Date()).add(-1, 'days').format('YYYY-MM-DD')
        if (zt === tv) {
          return mt.format('昨天 HH:mm')
        }
        return mt.format('YYYY-MM-DD HH:mm')
      }
      return mt.format('今天 HH:mm')
    },
    formatVal(value) {
      return value.toFixed()
    },
    // 时间格式化
    getDuraStr(sec) {
      var strDura = ''
      var dura = 0
      if (sec >= 86400) {
        dura = Number.parseInt(sec / 60 / 60 / 24);
        strDura = dura + ' 天';
      } else if (sec >= 3600) {
        dura = Number.parseInt(sec / 60 / 60);
        strDura = dura + ' 小时';
      } else if (sec >= 60) {
        dura = Number.parseInt(sec / 60);
        strDura = dura + ' 分钟';
      } else {
        strDura = dura + ' 秒';
      }
      return strDura
    }
  }
}
</script>

<style scoped>
.us-v-badge >>> .v-badge__badge{
  height: 5px !important;
  width: 5px !important;
}

.us-list-item >>> .v-list-item__icon{
  min-width: 0.9rem;
}

</style>

